/**
 * Pull only data properties (those with a `value` descriptor) off an object,
 * dropping getters/setters. Preserves T's value types when the input is typed.
 */
export default function extractObjectDataProperties<T extends object>(
  obj: T | null | undefined
): Partial<T> {
  if (obj == null) return {};

  const result: Partial<T> = {};
  for (const [key, desc] of Object.entries(
    Object.getOwnPropertyDescriptors(obj)
  )) {
    if (Object.hasOwn(desc, 'value')) {
      (result as Record<string, unknown>)[key] = desc.value;
    }
  }
  return result;
}
